import { Box, Container, Typography, Button, Grid } from "@mui/material";
import ColorData from "../../Components/CstmTheme/ColorData";

const SetupBusinessSection = () => {
  return (
    <Box
      component="section"
      className="setup-business-section"
      sx={{
        py: 6,
        backgroundColor: ColorData.primary.main,
      }}
    >
      <Container>
        <Typography
          variant="h4"
          gutterBottom
          className="section-heading setup-business-title"
          sx={{ color: ColorData.text.secondary, textAlign: "center" }}
        >
          Feeling Confused - Setup Your Business with Us
        </Typography>

        <Grid container justifyContent="center">
          <Grid item xs={12} md={10}>
            <Box
              className="setup-business-card"
              sx={{
                maxWidth: 900,
                mx: "auto",
                color: ColorData.text.secondary,
                textAlign: "center",
              }}
            >
              <Typography
                variant="body1"
                color={ColorData.text.secondary}
                className="section-text setup-business-subtitle"
                sx={{
                  fontWeight: 300,
                  mb: 3,
                }}
              >
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries, but also the leap into
                electronic typesetting, remaining essentially unchanged.
              </Typography>

              <Button
                variant="outlined"
                className="btn-contact"
                sx={{
                  backgroundColor: ColorData.text.secondary,
                  color: ColorData.text.primary,
                  border: "1px solid var(--text-color-2)",
                  fontWeight: 400,
                  "&:hover": {
                    backgroundColor: "transparent",
                    color: ColorData.text.secondary,
                  },
                }}
              >
                Contact Us
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default SetupBusinessSection;
